// extracted by mini-css-extract-plugin
module.exports = {"container":"FolderBreadcrumbs_container__3c8L0","link":"FolderBreadcrumbs_link__3YYJF"};